import React from 'react';
// import { Redirect} from 'react-router-dom'
import {Navigate} from 'react-router-dom'

import {connect} from 'react-redux'
import Loader from './Components/Loader';
import LayoutComponent from './Components/Layout'
import MobileUpdate from './Components/MobileUpdate'
import MobileConfirm from './Components/MobileConfirm'
import EmailConfirm from './Components/EmailConfirm'
// import BusinessRequirementsModal from './Components/BusinessRequirementsModal'
import * as authActions from './actions/authActions'
import Config from './Helpers/Config'
import BusinessWaitingApprove from "./Components/BusinessWaitingApprove";


class Layout extends React.Component {

    UNSAFE__componentWillReceiveProps(nextProps) {
        if (nextProps.auth.business && nextProps.auth.business.slug) {
            if (nextProps.auth.businesses.length && this.props.match.params.businessSlug !== '404' && this.props.match.params.businessSlug !== this.props.auth.business.slug) {
                this.props.selectBusiness(nextProps.auth.businesses.reduce((result, item) => {
                    if (item.slug === this.props.match.params.businessSlug) {
                        result = item;
                    }
                    return result;
                }, {}));
            }
        }
    }

    render() {
        let view = null;
        let {children, ...rest} = this.props;

        if (this.props.auth.fetched) {
            if (!this.props.auth.logged_in) {
                if (this.props.match.pathname !== '/login') {
                    view = <Navigate to={{pathname: '/login'}}/>
                } else {
                    view = children;
                }
            } else {
                if (!this.props.auth.business) {
                    window.location = `${Config.mainUrl('business/submit')}`;
                    return;
                }
                let businessExists = this.props.auth.businesses.some((business) => {
                    if (this.props.match.params.businessSlug === business.slug) {
                        return true
                    }
                    return false;
                });

                if (!businessExists) {
                    // console.log('this.props.auth',this.props)
                    if (this.props.auth.businesses.length){
                        const selectedBusinessId = localStorage.getItem('default_business');
                        let selectedBusiness = null;
                        if(selectedBusinessId){
                            selectedBusiness = this.props.auth.businesses.filter(businesse => parseInt(businesse.id,10) === parseInt(selectedBusinessId,10))[0];
                        }
                        if (!selectedBusiness){
                            selectedBusiness = this.props.auth.businesses[0];
                        }

                        // this.props.selectBusiness(this.props.auth.businesses[0]);
                        view = <Navigate to={{pathname: `/${selectedBusiness.slug}/orders`}}/>
                    }else{
                    view = <Navigate to={{pathname: '/404'}}/>
                    }
                } else {
                    let subView = null;
                    view = children;
                    // console.log('this.props.auth.businesses',this.props.auth.business.is_approved)
                    if(!this.props.auth.business.is_approved){
                        view = <BusinessWaitingApprove  />
                    }else if (this.props.ui.updateMobile) {
                        subView = <MobileUpdate opened={true}/>
                    } else if (this.props.ui.confirmMobile) {
                        subView = <MobileConfirm opened={true}/>
                    } else if (this.props.ui.confirmEmail) {
                        subView = <EmailConfirm opened={true}/>
                    } else {
                        // subView = <BusinessRequirementsModal auth={this.props.auth} />
                    }
                    view = (
                        <LayoutComponent logoUrl={`/${this.props.match.params.businessSlug}/search`} {...this.props}>
                            {subView}
                            {view}
                        </LayoutComponent>
                    )
                }
            }
        }

        return (<Loader completed={this.props.auth.fetched}>{view}</Loader>)
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        ui: state.ui
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({
    selectBusiness: (business) => dispatch(authActions.selectBusiness(business))
});
export default connect(mapStateToProps, mapDispatchToProps)(Layout);

